<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0 d-flex">
			<i-filter :category="product_category" @cari="cari"></i-filter>
		</div>
		<div class="col-12 pl-2 pr-2">
			<div class="row" v-show="dataProduk.length == 0">
				<div class="col-6 col-md-4 col-lg-3 mt-3 pr-2 pl-2" v-for="(product, index) in 4" :key="index">
					<div class="col-12 p-0 output-search rounded cus-box-shadow">
						<div class="col-12 p-0 output-search-nohover rounded-cus">
							<vcl :width="100" :height="140">
								<rect x="6" y="10" rx="2" ry="2" width="88" height="80" />
								<rect x="6" y="98" rx="2" ry="2" width="80" height="9" />
								<rect x="6" y="110" rx="2" ry="2" width="70" height="9" />
								<rect x="6" y="122" rx="2" ry="2" width="60" height="9" />
							</vcl>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="dataProduk == 'error'">
				<div class="col-12 pl-2 pr-2 d-flex mt-3">
					<div class="col-12 bg-white rounded-cus cus-box-shadow">
						<div class="col-6 col-md-4 ml-auto mr-auto pt-2 mb-3">
							<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
						</div>
						<div class="font-size-11 font-size-sm-10 pt-1 pb-2 text-center">Data produk tidak ditemukan!</div>
					</div>
				</div>
			</div>
			<div class="row" v-else>
				<div class="col-6 col-md-4 col-lg-3 mt-3 pr-2 pl-2" v-for="(product, index) in dataProduk" :key="index">
					<div @mouseover="selectProduct(index)" class="col-12 p-0 output-search rounded cus-box-shadow"
						v-if="product.product_to_po_mb == 'true'">
						<div class="output-search-hover position-absolute rounded">
							<div class="col-12 font-size-8 color-white pt-3"><span class="cursor-pointer d-flex justify-content-center"
									@click="detailProduct(product.product_name, product.product_description, product.product_image_filename)"><i
										class="fas fa-info-circle mr-2"></i>Detail Produk</span></div>
							<div class="col-12 text-center font-size-9 color-white font-weight-bold pt-2 pt-md-4 font-size-sm-10">
								<b><span>Quantity</span></b>
							</div>
							<div class="col-12 pt-2 d-flex justify-content-center">
								<button @click="minQty(index)" class="btn no-box-focus p-0 color-white btn-hover mr-2 mt-n1">
									<span class="font-size-16"><i class="fas fa-minus-circle"></i></span>
								</button>
								<input @keypress="onlyNumber" @paste.prevent type="text" v-model="product.quantity"
									class="col-6 form-control form-control-sm font-size-9 font-weight-bold no-box-focus text-center"
									placeholder="0">
								<button @click="addQty(index)" class="btn no-box-focus p-0 color-white btn-hover ml-2 mt-n1">
									<span class="font-size-16"><i class="fas fa-plus-circle"></i></span>
								</button>
							</div>
							<div class="col-12 pt-2 d-flex justify-content-center">
								<span class="color-white">{{ product.msg }}</span>
							</div>
							<div class="col-12 p-0 text-center pt-5">
								<button @click="addCart(product, index)"
									class="col-12 pl-0 pr-0 btn btn-add-cart rounded font-size-sm-7 color-white no-box-focus text-capitalize font-weight-bold btn-hover">
									<span class="pr-1 pr-md-2 font-size-10"><img
											src="/assets/transaction/icon-tambah-kekeranjang.svg"></span>tambah keranjang
								</button>
							</div>
						</div>
						<div class="col-12 p-0 output-search-nohover rounded-cus">
							<div class="col-12 p-3 text-center">
								<img :src="product.product_image" class="img-fluid rounded" style="height:155px;">
							</div>
							<div class="col-12 pl-0 pr-0 pb-2 desc-product">
								<div class="col-12 font-size-sm-9 font-size-10 mt-n1 d-flex">
									{{ product.product_name }}
								</div>
								<div class="col-12 font-size-sm-9 font-size-11 color-purple d-flex">
									{{ product.price | toRupiah }}
									<!-- {{ (stockist_order_count >= 4 || stockist_level == 'mb') ? (product.product_price_original ? product.product_price_original : 0) : (product.product_price ? product.product_price : 0) | toRupiah }} -->
								</div>
								<div class="col-12 font-size-sm-8 font-size-9 d-flex mt-1 mb-1">
									<!-- <img src="/assets/transaction/icon-stok.svg">
									<div class="col-12 pl-1 mt-auto mb-auto color-mila">Stok {{product.stock_pos}}</div> -->
									<span class="rounded-pill bg-blue color-white pr-2 pl-2">BV {{ product.product_bv }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 p-0 output-search rounded cus-box-shadow" v-else>
						<div class="output-search-hover position-absolute rounded">
							<div class="col-12 font-size-8 color-white pt-3"><span class="cursor-pointer d-flex justify-content-center"><i
										class="fas fa-info-circle mr-2"></i>Detail Produk</span></div>
							<div
								class="col-12 text-center font-size-12 color-white font-weight-bold pt-2 pt-md-5 font-size-sm-10 text-uppercase">
								<b><span>stok tidak tersedia</span></b>
							</div>
							<!-- <div class="col-12 pt-2 d-flex justify-content-center font-size-14 color-white text-uppercase">
								<b><span>kosong</span></b>
							</div> -->
						</div>
						<div class="col-12 p-0 output-search-nohover rounded-cus">
							<div class="col-12 p-3 text-center">
								<img :src="product.product_image" class="img-fluid rounded out-of-stock">
							</div>
							<div class="col-12 pl-0 pr-0 pb-2">
								<div class="col-12 font-size-sm-9 font-size-10 mt-n1 d-flex">
									{{ product.product_name }}
								</div>
								<div class="col-12 font-size-sm-9 font-size-11 color-purple d-flex">
									{{ product.product_price | toRupiah }}
								</div>
								<div class="col-12 font-size-sm-8 font-size-9 d-flex pt-1 pb-1">
									<!-- <img src="/assets/transaction/icon-stok.svg">
									<div class="col-12 pl-1 mt-auto mb-auto color-mila">Stok Kosong</div> -->
									<span class="rounded-pill bg-blue color-white pr-2 pl-2">BV {{ product.product_bv }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<i-modal ref="modalDetailProduct" class="modal-small modal-detail-product">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="col-12 font-size-11 pt-2 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0">
						<div class="col-12">
							<button class="btn no-box-focus"><span @click="hideDetailProduct" class="close-modal ml-2 color-white mt-n2"><i
										class="fas fa-times"></i></span></button>
						</div>
						<div class="col-12 text-center mb-n4">
							<img :src="product_image" width="35%">
						</div>
						<div class="col-12 p-4 bg-white rounded-top-3">
							<div class="col-12 text-center font-size-12 font-weight-bold">{{ nama_produk }}</div>
							<div class="col-12 text-center pt-3" v-if="deskripsi_produk">{{ deskripsi_produk }}.</div>
							<div class="col-12 text-center pt-5 pb-5" v-else>Deskripsi Tidak Tersedia.</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal"></div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import IFilter from '@/components/IFilter.vue';
import IModal from '@/components/IModal.vue';
import $ from 'jquery';

export default {
	components: {
		IModal, IFilter
	},
	data() {
		return {
			search: '',
			category: '',
		}
	},
	computed: {
		...mapState('po_cart', ['dataProduk', 'product_category', 'step', 'cart', 'registerItem']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('po_cart', ['getDataProduk', 'getDataCategory', 'saveCart', 'changeProductQty', 'getMinimumBV', 'getProgressivePrice']),
		//...mapActions('po', ['getProduct']),
		...mapMutations('po_cart', ['step_up', 'step_down', 'setAlert', 'cariProduk']),

		cari(value, category) {
			this.cariProduk({
				value: value,
				category: category
			})
		},
		selectProduct(index) {
			this.selectedProduct = this.dataProduk[index]
		},
		addQty(index) {
			this.changeProductQty({
				type: 'plus',
				index: index
			})
		},
		minQty(index) {
			this.changeProductQty({
				type: 'min',
				index: index
			})
		},
		async addCart(val, index) {
			var data = Object.assign({}, val);
			this.saveCart({ product: data, index: index })
			var sc = $('#shop-cart-container').offset().top
			$('html').scrollTop(sc)
		},
		detailProduct(nama, deskripsi, image) {
			this.nama_produk = nama
			this.deskripsi_produk = deskripsi
			this.product_image = image
			this.$refs.modalDetailProduct.modalShow()
		},
		detailReport() {
			this.$refs.modalDetail.modalShow()
		},
		hideDetailProduct() {
			this.$refs.modalDetailProduct.modalHide()
			this.nama_produk = ''
			this.deskripsi_produk = ''
		},
		// setStockist() {
		// 	this.stockist_level = this.userData.stockist_level
		// 	this.stockist_order_count = this.userData.stockist_order_count
		// }
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Belanja Produk');
		this.getDataProduk({ stockist_level: this.userData.stockist_level, stockist_order_count: this.userData.stockist_order_count })
		this.getDataCategory()
		this.getMinimumBV()
		this.getProgressivePrice()
	},

};
</script>
